// extracted by mini-css-extract-plugin
export default {"footer-attribution":"Attribution_footer-attribution__r1f2H"};